import React from 'react';
import AboutSection from '../sections/AboutSection';

export default function About() {
  return (
    <div style={{ paddingTop: 72 }}>
      <AboutSection />
    </div>
  );
}
